import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.sun-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "sun-icon-st0",
		d: "M4.1,13H0v-2h4.1C4,11.3,4,11.7,4,12S4,12.7,4.1,13z M7.1,5.7L4.2,2.8L2.8,4.2l2.9,2.9C6.1,6.6,6.6,6.1,7.1,5.7 z M18.3,7.1l2.9-2.9l-1.4-1.4l-2.9,2.9C17.4,6.1,17.9,6.6,18.3,7.1z M12,4c0.3,0,0.7,0,1,0.1V0h-2v4.1C11.3,4,11.7,4,12,4z M12,20 c-0.3,0-0.7,0-1-0.1V24h2v-4.1C12.7,20,12.3,20,12,20z M19.9,11c0,0.3,0.1,0.7,0.1,1s0,0.7-0.1,1H24v-2H19.9z M16.9,18.3l2.9,2.9 l1.4-1.4l-2.9-2.9C17.9,17.4,17.4,17.9,16.9,18.3z M5.7,16.9l-2.9,2.9l1.4,1.4l2.9-2.9C6.6,17.9,6.1,17.4,5.7,16.9z M8,12 c0,2.2,1.8,4,4,4s4-1.8,4-4s-1.8-4-4-4S8,9.8,8,12z M18,12c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6S18,8.7,18,12z"
	})]
});
export default SvgSunIcon;
